import type { ApolloError } from '@apollo/client/errors'

import { useRecalculateCurrentIterationVelocity, useUpdateCache } from '@/requests/apollo/useUpdateCache.ts'
import { useMutateStory } from '@/requests/mutations/useMutateStory.ts'
import { isTemporaryId } from '@/utils/key.ts'
import { GlobalPubSub } from '@/utils/pubsub.ts'

export const useMutateStoryAcceptedAt = (storyId: string) => {
  const { recalculateCurrentIterationVelocity } = useRecalculateCurrentIterationVelocity()
  const { mutate } = useMutateStory(storyId)
  const { updateStory } = useUpdateCache()

  return {
    mutate: (value: number, onError?: (error: ApolloError) => void) => {
      GlobalPubSub.publish(GlobalPubSub.Signals.DESELECT_STORIES, storyId)

      if (isTemporaryId(storyId)) {
        updateStory(storyId, { acceptedAt: value })
        recalculateCurrentIterationVelocity()
        return Promise.resolve()
      }

      recalculateCurrentIterationVelocity()

      return mutate({ acceptedAt: value }, { onError })
    },
  }
}
